import { forwardRef } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { BiEdit } from "react-icons/bi";
import { BsThreeDots } from "react-icons/bs";
import { RiDeleteBinLine } from "react-icons/ri";
import editIcon from "../../../resources/images/pencile.svg"
import flagIcon from "../../../resources/images/flagIcon.svg"
import deleteIcon from "../../../resources/images/delete.svg"
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { ApplicantActions } from "../../../actions";
const CustomToggle = forwardRef(({ children, onClick }, ref) => (
    <span
        className="card-action-drop-down"
        ref={ref}
        onClick={(e) => {
            e.preventDefault();
            onClick(e);
        }}
    >
        {children}
        <BsThreeDots />
    </span>
));
const CardActionMenu = (props) => {
    const user = useSelector((state) => state.authentication.user);
    const deleteClick = () => {
        if (props?.row?.id) {
            props.setDeleteId(props?.row?.id);
        }
    };
    const addFlag = () => {
        if (props?.row?.id) {
            props.setActiveData(props?.row);
        }
    }
    const dispatch = useDispatch()
    const editData = useSelector((state) => state.applicant.boardApplicant)
    const editClick = () => {
        dispatch(ApplicantActions.getApplicant(props?.row?.id)).then(res => {
            if (res) {
                props.setEditedData(res)
            }
        })


    }
    return (
        <Dropdown className="drop">
            <Dropdown.Toggle as={CustomToggle} />
            <Dropdown.Menu className="drop-itm">
                {user && user?.userRole !== 4 ?
                    <Dropdown.Item onClick={() => editClick()}>
                        {" "}
                        <img src={editIcon} className="drop-icon" /> Edit
                    </Dropdown.Item> : ""
                }

                {props?.flag ?
                    <>
                        <Dropdown.Item onClick={() => addFlag()}>
                            {" "}
                            <img src={flagIcon} className="drop-icon" /> {props?.row?.flagged ? 'Remove Flag' : 'Add Flag'}
                        </Dropdown.Item>
                        {user && user?.userRole !== 4 ?
                            <Dropdown.Item onClick={() => deleteClick()}>
                                {" "}
                                <img src={deleteIcon} className="drop-icon" /> Delete
                            </Dropdown.Item> : ""
                        }

                    </>
                    : ""}


            </Dropdown.Menu>
        </Dropdown>
    );
};

export default CardActionMenu;
